import { useCallback, useMemo } from 'react'
import { useQueryParams, useChangeHistory } from 'flow/queryparams'
import relationsProperties from 'data/output/relations-properties.json'

const sortAlpha = (a, b) => {
  return a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: 'base'
  })
}

// relations categories
const relationCategoriesAll = relationsProperties.categories.sort(sortAlpha)
export function useRelationCategories () {
  const changeHistory = useChangeHistory()
  const { excludedRelationCategories } = useQueryParams()

  const action = useCallback((selectedItems) => {
    changeHistory({
      excludedRelationCategories: relationCategoriesAll.filter((d) => !selectedItems.includes(d))
    })
  }, [changeHistory])

  const selectedRelationCategories = useMemo(() => {
    const params = excludedRelationCategories || []
    return relationCategoriesAll.filter((d) => !params.includes(d))
  }, [excludedRelationCategories])

  return [
    selectedRelationCategories,
    relationCategoriesAll,
    action
  ]
}

// relations types
const relationTypesAll = relationsProperties.types.sort(sortAlpha)

export function useRelationTypes () {
  const changeHistory = useChangeHistory()
  const { excludedRelationTypes } = useQueryParams()

  const action = useCallback((selectedItems) => {
    changeHistory({
      excludedRelationTypes: relationTypesAll.filter((d) => !selectedItems.includes(d))
    })
  }, [changeHistory])

  const selectedRelationTypes = useMemo(() => {
    const params = excludedRelationTypes || []
    return relationTypesAll.filter((d) => !params.includes(d))
  }, [excludedRelationTypes])

  return [
    selectedRelationTypes,
    relationTypesAll,
    action
  ]
}

export function useShowRelation () {
  const changeHistory = useChangeHistory()
  const { showRelations } = useQueryParams()
  const currentValue = (showRelations === 'true')

  const action = useCallback(
    (value) => {
      changeHistory({
        showRelations: value
      })
    },
    [changeHistory]
  )

  return [
    currentValue,
    action
  ]
}
